
import initCustomScrollbar from "../modules/init-custom-scrollbar.js";

const initBlock = async function( block ) {
	const $slider = block.find( "[data-position-slider]" );
	if ( !$slider.length ) {
		return;
	}

	const { Swiper } = await import( "swiper" );
	const { Pagination } = await import( "swiper/modules" );
	await import( "../scrollbar.min.js" );
	await import( "swiper/css" );
	await import( "swiper/css/pagination" );

	new Swiper( $slider[0], {
		modules: [Pagination],
		slidesPerView: "auto",
		slidesPerGroup: 1,
		allowTouchMove: true,
		spaceBetween: 20,
		breakpoints: {
			767: {
				slidesPerView: 3,
			},
			1279: {
				slidesPerView: 4,
			},
		},
		pagination: {
			el: block.find( "[data-slider-pagination]" )[0],
			type: "bullets",
			clickable: true,
			dynamicBullets: true,
			dynamicMainBullets: 3,
		},
	} );


	initCustomScrollbar( block );
};

themeUtils.loadBlock( initBlock, "available-positions", ".section-available-positions" );
